import { toValuesAndInvalidations } from './drawSelectionMask';
import { SELECTION_MASK_TOUCH_START } from '@graphistry/viz/src/actions/scene';
import { createSubject, SceneGestures } from '../support';

export function moveSelectionMask(actions) {
    const moveMaskStarts = SceneGestures.startFromActions(
        actions
            .ofType(SELECTION_MASK_TOUCH_START)
            .filter(
                ({ event, simulating, selectionMask, selectionType }) =>
                    !simulating &&
                    !event.button &&
                    selectionMask &&
                    selectionType === 'window' &&
                    !event.getModifierState('Shift')
            )
            .do(({ event }) => event.persist())
    );

    const movedMaskSelections = SceneGestures
        .pan(moveMaskStarts)
        .repeat()
        .mergeMap((drag) => drag
            .skip(1)
            .stopPropagation(true)
            .moveRectInWorldCoords()
            .multicast(createSubject, (drag) =>
                drag.merge(drag.takeLast(1).map(point => {
                    point.refreshMask = true;
                    return point;
                }))
            )
        );

    return movedMaskSelections.map(toValuesAndInvalidations);
}
